var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import MeetingStatusDomainService from "../Domain/MeetingStatus/MeetingStatus.service";
import { getApiClient } from "../../services/AxiosClients";
const BASE_URL = "/aviso/meetingStatus";
export default class MeetingStatusService {
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchResults = yield FetchService.getPagedResponse(BASE_URL + "/search", Object.assign(Object.assign({ query: search === null || search === void 0 ? void 0 : search.query, ids: search.ids, excludeIds: search.excludeIds }, search), options));
            return Object.assign(Object.assign({}, searchResults), { data: searchResults.data.map(MeetingStatusDomainService.fromJSON) });
        });
    }
    static get(meetingStatusId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/get", {
                id: meetingStatusId,
            });
        });
    }
    static toggleActive(meetingStatusId) {
        return FetchService.postSingleResponse(BASE_URL + "/toggleActive", {
            id: meetingStatusId,
        });
    }
    static searchAll(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/meetingStatuses/search/findByNameContainingIgnoreCase", {
                params: { search, sort: "name", order: "ASC", size: 30 },
            });
            return response.data._embedded.meetingStatuses;
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/meetingStatuses/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.meetingStatuses;
        });
    }
}
